/*
 * Exit / search popup — trigger + open/close logic. Replaces ConvertCart's
 * exit-intent search popup. The search box itself is the theme's native
 * <search-form> (predictive dropdown), so this file only handles WHEN the modal
 * shows (exit-intent / time delay / scroll), how often, and dismissal.
 * Config comes from data-* attributes on #aro-esp. Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  var root = document.getElementById('aro-esp');
  if (!root) return;

  var trigger = root.getAttribute('data-trigger') || 'exit_intent';
  var delay = parseInt(root.getAttribute('data-delay'), 10) || 10;
  var scrollPct = parseInt(root.getAttribute('data-scroll'), 10) || 50;
  var frequency = root.getAttribute('data-frequency') || 'once_session';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var KEY = 'aro_esp_seen';
  var opened = false;
  var handlers = [];

  function teardown() {
    handlers.forEach(function (off) { off(); });
    handlers = [];
  }

  function alreadySeen() {
    if (frequency === 'every_visit') return false;
    try {
      if (frequency === 'once_session') return sessionStorage.getItem(KEY) === '1';
      if (frequency === 'once_day') {
        var ts = parseInt(localStorage.getItem(KEY), 10);
        return !!ts && (Date.now() - ts) < 86400000;
      }
    } catch (e) {}
    return false;
  }

  function markSeen() {
    try {
      if (frequency === 'once_session') sessionStorage.setItem(KEY, '1');
      else if (frequency === 'once_day') localStorage.setItem(KEY, String(Date.now()));
    } catch (e) {}
  }

  function open() {
    if (opened) return;
    opened = true;
    teardown();
    root.hidden = false;
    root.classList.add('is-open');
    document.body.classList.add('aro-esp-open');
    if (!designMode) markSeen();
    var input = root.querySelector('#exit-search-input');
    if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 50);
  }

  function close() {
    opened = false;
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.classList.remove('aro-esp-open');
  }

  root.querySelectorAll('[data-esp-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && opened) close();
  });

  // Theme editor: preview on section select; never auto-trigger.
  if (designMode) {
    document.addEventListener('shopify:section:select', open);
    document.addEventListener('shopify:section:deselect', close);
    return;
  }

  if (alreadySeen()) return;

  function fire() { if (!opened && !alreadySeen()) open(); }

  if (trigger === 'time_delay') {
    var t = setTimeout(fire, delay * 1000);
    handlers.push(function () { clearTimeout(t); });
  } else if (trigger === 'scroll') {
    var onScroll = function () {
      var sc = window.scrollY || document.documentElement.scrollTop;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (sc / h) * 100 >= scrollPct) fire();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    handlers.push(function () { window.removeEventListener('scroll', onScroll); });
  } else {
    // exit_intent (desktop): pointer leaves through the top of the viewport.
    var onLeave = function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) fire();
    };
    document.addEventListener('mouseout', onLeave);
    handlers.push(function () { document.removeEventListener('mouseout', onLeave); });
  }
})();
